// JSON-LD of every page, built from its route and texts.
//
// - The home is a WebSite published by Localranker.
// - Each tool is a free WebApplication, with a breadcrumb back to the home of
//   its language.
// No rating is declared: the tools have no real reviews to show.

import { ROUTES, SITE_URL, absoluteUrl } from "./routes";

const ORGANIZATION = {
  "@type": "Organization",
  "@id": "https://localranker.fr/#organization",
  name: "Localranker",
  url: "https://localranker.fr/",
  logo: `${SITE_URL}/android-chrome-512x512.png`,
};

const HOME_NAME = { fr: "Outils gratuits Localranker", en: "Localranker free tools" };
const CURRENCY = { fr: "EUR", en: "USD" };

// "Audit Store Locator gratuit - Analysez vos pages | LocalRanker" -> "Audit Store Locator gratuit"
export const toolName = (title) => title.split(/\s+[|–-]\s+/)[0].trim();

export const buildStructuredData = ({ routeId, lang, title, description }) => {
  const url = absoluteUrl(ROUTES[routeId][lang]);
  const homeUrl = absoluteUrl(ROUTES.home[lang]);

  if (routeId === "home") {
    return [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": `${homeUrl}#website`,
        name: HOME_NAME[lang],
        url: homeUrl,
        description,
        inLanguage: lang,
        publisher: ORGANIZATION,
      },
    ];
  }

  const name = toolName(title);
  return [
    {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "@id": `${url}#app`,
      name,
      url,
      description,
      inLanguage: lang,
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web",
      isAccessibleForFree: true,
      offers: { "@type": "Offer", price: "0", priceCurrency: CURRENCY[lang] },
      publisher: ORGANIZATION,
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: HOME_NAME[lang], item: homeUrl },
        { "@type": "ListItem", position: 2, name, item: url },
      ],
    },
  ];
};

// Share image of a page: public/og/<routeId>-<lang>.png (scripts/og-images.js).
export const shareImageUrl = (routeId, lang) => `${SITE_URL}/og/${routeId}-${lang}.png`;
